
export default function ({ value }: { value: string }) {


    return <span className={0.0 > parseFloat(value as string) ? "text-error" : "text-success"}>
        {value}
    </span>
}